'use client';

import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function MainHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#12375C] text-white">
      <div className="max-w-[1200px] mx-auto px-4 py-2 flex items-center justify-between">
        <Link href="/" className="hover:opacity-50 transition-opacity">
          <Image
            src="/images/logo_03.png"
            alt="당나귀배송"
            width={240}
            height={64}
            className="h-11 sm:h-16 w-auto"
            // style={{ filter: 'brightness(0) saturate(100%) invert(76%) sepia(67%) saturate(420%) hue-rotate(6deg) brightness(101%) contrast(87%)' }}
            priority
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden sm:flex items-center gap-6 text-sm">
          <Link href="/reservation" className="hover:text-[#4DA3FF] transition-colors">
            예약하기
          </Link>
          <Link href="/contact" className="hover:text-[#4DA3FF] transition-colors">
            문의하기
          </Link>
          <Link href="/lookup" className="hover:text-[#4DA3FF] transition-colors">
            조회하기
          </Link>
        </nav>

        {/* Mobile hamburger button */}
        <button
          className="sm:hidden p-1.5"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="메뉴 열기"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <nav className="sm:hidden bg-[#15314D] border-t border-white/10 px-4 py-3 flex flex-col gap-5 text-sm">
          <Link href="/reservation" className="hover:text-[#4DA3FF] transition-colors" onClick={() => setMenuOpen(false)}>
            예약하기
          </Link>
          <Link href="/contact" className="hover:text-[#4DA3FF] transition-colors" onClick={() => setMenuOpen(false)}>
            문의하기
          </Link>
          <Link href="/lookup" className="hover:text-[#4DA3FF] transition-colors" onClick={() => setMenuOpen(false)}>
            조회하기
          </Link>
        </nav>
      )}
    </header>
  );
}
